import { Navigate } from 'react-router-dom';

import { ProtectedRoute } from '../authentication/ProtectedRoute.jsx';
import { RoleProtectedRoute } from '../authentication/RoleProtectedRoute.jsx';
import Cheats from "../pages/user/dev-tools/Cheats.jsx";
import { CHEATS_CATALOG } from '../config/cheatsCatalog.jsx';

const cheatsRoutes = [
    {
        path: '/cheats',
        // Developer Tools are super-user-only and NOT grantable via RBAC — the parent gate covers
        // every child route (the per-child pagePath checks are defence-in-depth).
        element: (
            <ProtectedRoute>
                <RoleProtectedRoute superUserOnly>
                    <Cheats />
                </RoleProtectedRoute>
            </ProtectedRoute>
        ),
        children: [
            { path: '', element: <Navigate to="dashboard" replace /> },
            // Every tool derives from the single cheats catalog (config/cheatsCatalog.jsx).
            // Guard against a catalog entry whose `path` is undefined (e.g. a PAGES.* constant
            // missing from the generated pagePaths after an out-of-sync rbac regenerate) — without
            // it, a single bad entry throws in .replace() and white-screens the entire app.
            ...CHEATS_CATALOG
                .filter(({ path }) => {
                    if (!path) {
                        console.warn('[cheatsRoutes] Skipping catalog entry with undefined path:', path);
                        return false;
                    }
                    return true;
                })
                .map(({ path, component: Component }) => ({
                    path: path.replace('/cheats/', ''),
                    element: <RoleProtectedRoute pagePath={path}><Component /></RoleProtectedRoute>,
                })),
        ],
    },
];

export default cheatsRoutes;
